import { CommonModule, DatePipe, NgOptimizedImage } from '@angular/common'
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'

import {
  NgArrayPipesModule,
  NgPipesModule,
  NgStringPipesModule,
} from 'ngx-pipes'

import { EditorsService } from '../api/editors-service/editors.service'
import { FilterService } from '../api/filter-service/filter.service'
import { EditionComponentsModule } from '../features/magazines-and-journals/magazines-and-journals-detail-page/components/edition-components.module'
import { SEMagazineArticlesComponent } from '../features/magazines-and-journals/se-magazine-articles/se-magazine-articles.component'
import { FormatAuthorNamePipe } from '../shared/pipes/format-author-name.pipe'
import { LocalizedDatePipe } from '../shared/pipes/localized-date.pipe'
import { TruncateCleanPipe } from '../shared/pipes/truncate-clean.pipe'
import { SharedModule } from '../shared/shared.module'
import { ArticleList } from './article-list'
import { ArticleMetaData } from './article-list/components/article-meta-data'
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component'
import { ChipFilterComponent } from './chip-filter/chip-filter.component'
import { DetailsHeaderComponent } from './details-header/details-header.component'
import { EditorialBoardComponent } from './editorial-board/editorial-board.component'
import { FilterModule } from './filter/filter.module'
import { FooterComponent } from './footer/footer.component'
import { GetNotificationsSectionComponent } from './get-notifications-section/get-notifications-section.component'
import { HeaderComponent } from './header/header.component'
import { MagazineTabsComponent } from './magazine-tabs/magazine-tabs.component'
import { AuthorGuidelinesComponent } from './magazine-tabs/tab-contents/author-guidelines/author-guidelines.component'
import { MoreInfoComponent } from './magazine-tabs/tab-contents/more-info/more-info.component'
import { PricesComponent } from './magazine-tabs/tab-contents/prices/prices.component'
import { MagazineComponent } from './magazine/magazine.component'
import { PaginationComponent } from './pagination/pagination.component'
import { SearchBarComponent } from './search-bar/search-bar.component'
import { SelectionEssenceViewComponent } from './selection-essence-view/selection-essence-view.component'
import { TabContentComponent } from './shared/tab-content/tab-content.component'
import { SiteBannerComponent } from './site-banner/site-banner.component'
import { SubmitButtonComponent } from './submit-button/submit-button.component'
import { SubscribeButtonComponent } from './subscribe-button/subscribe-button.component'
import { ToggleButtonComponent } from './toggle-button/toggle-button.component'
import { ToggleViewComponent } from './toggle-view/toggle-view.component'
import { UnpaidSubscriptionBannerComponent } from './unpaid-subscription-banner/unpaid-subscription-banner.component'
import { WelcomeDialogComponent } from './welcome-dialog/welcome-dialog.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    SharedModule,
    PaginationComponent,
    FilterModule,
    NgOptimizedImage,
    ReactiveFormsModule,
    NgArrayPipesModule,
    NgPipesModule,
    NgStringPipesModule,
    PaginationComponent,
    EditionComponentsModule,
    FilterModule,
    PaginationComponent,
    TruncateCleanPipe,
    LocalizedDatePipe,
    FormatAuthorNamePipe,
    ToggleViewComponent,
    FooterComponent,
    BreadcrumbsComponent,
    HeaderComponent,
    EditorialBoardComponent,
    MagazineComponent,
    SearchBarComponent,
    SelectionEssenceViewComponent,
    ChipFilterComponent,
    TabContentComponent,
    GetNotificationsSectionComponent,
    MagazineTabsComponent,
    SEMagazineArticlesComponent,
    ArticleList,
    ArticleMetaData,
    DetailsHeaderComponent,
    AuthorGuidelinesComponent,
    MoreInfoComponent,
    PricesComponent,
    SubmitButtonComponent,
    SubscribeButtonComponent,
    SiteBannerComponent,
    UnpaidSubscriptionBannerComponent,
    WelcomeDialogComponent,
    ToggleButtonComponent,
  ],
  exports: [
    ToggleViewComponent,
    FooterComponent,
    BreadcrumbsComponent,
    HeaderComponent,
    EditorialBoardComponent,
    MagazineComponent,
    SearchBarComponent,
    SelectionEssenceViewComponent,
    ChipFilterComponent,
    TabContentComponent,
    GetNotificationsSectionComponent,
    MagazineTabsComponent,
    SEMagazineArticlesComponent,
    ArticleList,
    ArticleMetaData,
    FilterModule,
    DetailsHeaderComponent,
    SubmitButtonComponent,
    SubscribeButtonComponent,
    SiteBannerComponent,
    UnpaidSubscriptionBannerComponent,
    WelcomeDialogComponent,
    ToggleButtonComponent,
  ],
  providers: [DatePipe, EditorsService, FilterService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ComponentsModule {}
